


// import React, { useState } from "react";

// const WorkoutPlanCard = ({
//   title,
//   duration,
//   originalPrice,
//   discountedPrice,
//   features,
//   isSelected,
//   isPurchased,
//   activeSubscription,
//   expiryDate,
//   onSelect,
// }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [showScrollButton, setShowScrollButton] = useState(false);
//   const featuresListRef = React.useRef(null);

//   const formatExpiry = (dateStr) => {
//     if (!dateStr) return null;
//     try {
//       const d = new Date(dateStr);
//       if (isNaN(d)) return dateStr;
//       return d.toISOString().split("T")[0];
//     } catch {
//       return dateStr;
//     }
//   };

//   const checkScroll = () => {
//     if (featuresListRef.current) {
//       const { scrollHeight, clientHeight, scrollTop } = featuresListRef.current;
//       setShowScrollButton(scrollHeight > clientHeight);
//       if (scrollTop === 0) setIsExpanded(false);
//     }
//   };

//   const handleScrollDown = () => {
//     if (featuresListRef.current) {
//       featuresListRef.current.scrollBy({ top: 100, behavior: "smooth" });
//       setIsExpanded(true);
//     }
//   };

//   const handleScrollUp = () => {
//     if (featuresListRef.current) {
//       featuresListRef.current.scrollBy({ top: -100, behavior: "smooth" });
//       setTimeout(() => {
//         if (featuresListRef.current.scrollTop === 0) setIsExpanded(false);
//       }, 200);
//     }
//   };

//   React.useEffect(() => {
//     checkScroll();
//     window.addEventListener("resize", checkScroll);
//     return () => window.removeEventListener("resize", checkScroll);
//   }, [features]);

//   // Active subscription card - Light theme with #BBE520 border
//   if (activeSubscription) {
//     return (
//       <div className="w-[320px] flex-shrink-0">
//         <div
//           className="rounded-2xl p-6 h-full flex flex-col bg-white shadow-lg"
//           style={{ 
//             border: `2px solid #BBE520`,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
//           }}
//         >
//           <div className="flex justify-between items-start mb-2">
//        <h3
//   className="font-bold text-lg tracking-wide uppercase"
//   style={{ color: isSelected ? "#BBE520" : "#1f2937" }}
// >
//   {title}
// </h3>

//           </div>
//           <p className="text-gray-500 text-xs mt-1 mb-3">{duration}</p>
//           {expiryDate && (
//             <p className="text-gray-500 text-sm mb-4 flex items-center gap-2">
//               <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               Expires on: {formatExpiry(expiryDate)}
//             </p>
//           )}
//           <hr className="border-gray-200 mb-4" />
//           <div className="relative flex-grow">
//             {showScrollButton && isExpanded && (
//               <button
//                 onClick={(e) => { e.stopPropagation(); handleScrollUp(); }}
//                 className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
//               >
//                 <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7" />
//                 </svg>
//               </button>
//             )}
//             <ul
//               ref={featuresListRef}
//               className={`space-y-3 overflow-y-auto transition-all duration-300 ${features.length > 3 ? "max-h-48 pr-2" : ""}`}
//               style={{ scrollbarWidth: "thin", scrollbarColor: "#BBE520 #f1f5f9" }}
//               onScroll={checkScroll}
//             >
//               {features.map((feature, index) => (
//                 <li key={index} className="flex items-start gap-3">
//                   <svg
//                     className="w-5 h-5 shrink-0 mt-0.5"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="#BBE520"
//                     strokeWidth="2"
//                   >
//                     <circle cx="12" cy="12" r="10" />
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
//                   </svg>
//                   <span className="text-gray-700 text-sm leading-snug">{feature}</span>
//                 </li>
//               ))}
//             </ul>
//             {showScrollButton && !isExpanded && (
//               <button
//                 onClick={(e) => { e.stopPropagation(); handleScrollDown(); }}
//                 className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
//               >
//                 <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Normal selectable card with white background
//   return (
//     <div
//       className="relative group cursor-pointer w-[320px] flex-shrink-0"
//       style={{ padding: "2px" }}
//       onClick={!isPurchased ? onSelect : undefined}
//     >
//       <div
//         className={`absolute inset-0 rounded-2xl transition duration-500 ${
//           isSelected ? "bg-[#BBE520]" : "bg-[#BBE520] opacity-30 group-hover:opacity-60"
//         }`}
//       ></div>
//       <div
//         className={`relative bg-white rounded-2xl p-6 h-full flex flex-col transition duration-300 ${
//           isSelected && !isPurchased ? "scale-[1.02]" : ""
//         }`}
//       >
//         {isSelected && !isPurchased && (
//           <div className="absolute top-3 right-3 bg-[#BBE520] text-black rounded-full p-1">
//             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
//             </svg>
//           </div>
//         )}

//         <h3 className="text-gray-800 font-bold text-lg tracking-wide uppercase">{title}</h3>
//         <p className="text-gray-500 text-xs mt-1 mb-4">{duration}</p>
//         <div className="mb-6">
//           <span className="text-gray-400 line-through text-base block">₹{originalPrice}</span>
//           <span className="text-4xl font-black text-gray-900">₹{discountedPrice}</span>
//         </div>

//         <div className="relative mb-6 flex-grow">
//           {showScrollButton && isExpanded && (
//             <button
//               onClick={(e) => { e.stopPropagation(); handleScrollUp(); }}
//               className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
//             >
//               <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7" />
//               </svg>
//             </button>
//           )}
//           <ul
//             ref={featuresListRef}
//             className={`space-y-3 overflow-y-auto transition-all duration-300 ${features.length > 3 ? "max-h-48 pr-2" : ""}`}
//             style={{ scrollbarWidth: "thin", scrollbarColor: "#BBE520 #f1f5f9" }}
//             onScroll={checkScroll}
//           >
//             {features.map((feature, index) => (
//               <li key={index} className="flex items-start gap-2">
//                 <svg className="w-5 h-5 text-[#BBE520] mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
//                 </svg>
//                 <span className="text-gray-700 text-sm leading-snug">{feature}</span>
//               </li>
//             ))}
//           </ul>
//           {showScrollButton && !isExpanded && (
//             <button
//               onClick={(e) => { e.stopPropagation(); handleScrollDown(); }}
//               className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
//             >
//               <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WorkoutPlanCard;

import React, { useState } from "react";

const WorkoutPlanCard = ({
  title,
  duration,
  originalPrice,
  discountedPrice,
  features,
  isSelected,
  isPurchased,
  activeSubscription,
  expiryDate,
  onSelect,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const featuresListRef = React.useRef(null);

  const formatExpiry = (dateStr) => {
    if (!dateStr) return null;
    try {
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      return d.toISOString().split("T")[0];
    } catch {
      return dateStr;
    }
  };

  const checkScroll = () => {
    if (featuresListRef.current) {
      const { scrollHeight, clientHeight, scrollTop } = featuresListRef.current;
      setShowScrollButton(scrollHeight > clientHeight);
      if (scrollTop === 0) setIsExpanded(false);
    }
  };

  const handleScrollDown = () => {
    if (featuresListRef.current) {
      featuresListRef.current.scrollBy({ top: 100, behavior: "smooth" });
      setIsExpanded(true);
    }
  };

  const handleScrollUp = () => {
    if (featuresListRef.current) {
      featuresListRef.current.scrollBy({ top: -100, behavior: "smooth" });
      setTimeout(() => {
        if (featuresListRef.current.scrollTop === 0) setIsExpanded(false);
      }, 200);
    }
  };

  React.useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [features]);

  // Active subscription card - Light theme with #BBE520 border
  if (activeSubscription) {
    return (
      <div className="w-[320px] flex-shrink-0">
        <div
          className="rounded-2xl p-6 h-full flex flex-col bg-white shadow-lg"
          style={{ 
            border: `2px solid #BBE520`,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
          }}
        >
          <div className="flex justify-between items-start mb-2">
        <h3 className="font-bold text-lg tracking-wide uppercase" style={{ color: "#BBE520" }}>
  {title}
</h3>
          </div>
          <p className="text-gray-500 text-xs mt-1 mb-3">{duration}</p>
          {expiryDate && (
            <p className="text-gray-500 text-sm mb-4 flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Expires on: {formatExpiry(expiryDate)}
            </p>
          )}
          <hr className="border-gray-200 mb-4" />
          <div className="relative flex-grow">
            {showScrollButton && isExpanded && (
              <button
                onClick={(e) => { e.stopPropagation(); handleScrollUp(); }}
                className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
              >
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7" />
                </svg>
              </button>
            )}
            <ul
              ref={featuresListRef}
              className={`space-y-3 overflow-y-auto transition-all duration-300 ${features.length > 3 ? "max-h-48 pr-2" : ""}`}
              style={{ scrollbarWidth: "thin", scrollbarColor: "#BBE520 #f1f5f9" }}
              onScroll={checkScroll}
            >
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <svg
                    className="w-5 h-5 shrink-0 mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#BBE520"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
                  </svg>
                  <span className="text-gray-700 text-sm leading-snug">{feature}</span>
                </li>
              ))}
            </ul>
            {showScrollButton && !isExpanded && (
              <button
                onClick={(e) => { e.stopPropagation(); handleScrollDown(); }}
                className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
              >
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Normal selectable card with white background
  return (
    <div
      className="relative group cursor-pointer w-[320px] flex-shrink-0"
      style={{ padding: "2px" }}
      onClick={!isPurchased ? onSelect : undefined}
    >
      <div
        className={`absolute inset-0 rounded-2xl transition duration-500 ${
          isSelected ? "bg-[#BBE520]" : "bg-[#BBE520] opacity-30 group-hover:opacity-60"
        }`}
      ></div>
      <div
        className={`relative bg-white rounded-2xl p-6 h-full flex flex-col transition duration-300 ${
          isSelected && !isPurchased ? "scale-[1.02]" : ""
        }`}
      >
        {isSelected && !isPurchased && (
          <div className="absolute top-3 right-3 bg-[#BBE520] text-black rounded-full p-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}

        {/* ✅ Title color changes to #BBE520 when selected */}
        <h3
          className="font-bold text-lg tracking-wide uppercase"
          style={{ color: isSelected ? "#BBE520" : "#1f2937" }}
        >
          {title}
        </h3>
        <p className="text-gray-500 text-xs mt-1 mb-4">{duration}</p>

        <div className="mb-6">
          <span className="text-gray-400 line-through text-base block">₹{originalPrice}</span>
          {/* ✅ Price color changes to #BBE520 when selected */}
          <span
            className="text-4xl font-black"
            style={{ color: isSelected ? "#BBE520" : "#111827" }}
          >
            ₹{discountedPrice}
          </span>
        </div>

        <div className="relative mb-6 flex-grow">
          {showScrollButton && isExpanded && (
            <button
              onClick={(e) => { e.stopPropagation(); handleScrollUp(); }}
              className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
            >
              <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7" />
              </svg>
            </button>
          )}
          <ul
            ref={featuresListRef}
            className={`space-y-3 overflow-y-auto transition-all duration-300 ${features.length > 3 ? "max-h-48 pr-2" : ""}`}
            style={{ scrollbarWidth: "thin", scrollbarColor: "#BBE520 #f1f5f9" }}
            onScroll={checkScroll}
          >
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <svg className="w-5 h-5 text-[#BBE520] mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700 text-sm leading-snug">{feature}</span>
              </li>
            ))}
          </ul>
          {showScrollButton && !isExpanded && (
            <button
              onClick={(e) => { e.stopPropagation(); handleScrollDown(); }}
              className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 z-10 transition-all duration-200 shadow-md"
            >
              <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkoutPlanCard;